/**
 * Chips row for active filters. Each chip: { key, label, onRemove }.
 * Optional onReset for "Сбросить" chip.
 */
export function FilterChips({ chips, onReset }) {
  if (!chips?.length && !onReset) return null;
  return (
    <div className="crmChips">
      {chips?.map(({ key, label, onRemove }) => (
        <button key={key} type="button" className="chip" onClick={onRemove}>
          {label} <span className="x">×</span>
        </button>
      ))}
      {onReset ? (
        <button type="button" className="chip" onClick={onReset}>
          Сбросить <span className="x">×</span>
        </button>
      ) : null}
    </div>
  );
}
